import Enum from "../../../enums/Enum";

const EnumCoPayUnit = new Enum({
    PERCENTAGE: "%",
    AED: "AED",
    KWD: "KWD",
});

export default EnumCoPayUnit;
